import { render } from "./CookieBanner.vue?vue&type=template&id=03fd02a4&scoped=true&ts=true"
import script from "./CookieBanner.vue?vue&type=script&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&lang=ts"

import "./CookieBanner.vue?vue&type=style&index=0&id=03fd02a4&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fd02a4"]])

export default __exports__